<!-- declared up here so the form's (ngSubmit) can be guarded too: submit is a form button, so pressing it submits the form -->
@let isSubmitting = isSubmitting$ | async;
<div class="dialog--title"
  cdkDrag
  cdkDragHandle
  cdkDragRootElement=".cdk-overlay-pane"
  [cdkDragFreeDragPosition]="position"
  (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.submitHoursRequest_title }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button type="button" class="button-reset" (click)="close(false)" [attr.aria-label]="data.sysText.cancel" [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content>
  <form id="submit-hours-form" [formGroup]="form" (ngSubmit)="!isSubmitting && onSubmit()">
    @if (data.dialogData.showEmployeeCasePickList) {
      <app-employee-case-picker
        [control]="employeeCase"
        [label]="data.sysText.employeeCase"
        [icon]="'person'"
        [group]="form"
        [isLoadingEmployee$]="isLoadingEmployee$"
        [employeeCaseOptions]="data.dialogData.employeeCaseOptions">
      </app-employee-case-picker>
    }
    <div class="info-fields">
      <div class="field-col">
        @if (data.dialogData.showEmployer) {
          <app-input-field
            [label]="data.sysText.employer"
            [control]="form.controls.employer"
            [isDisabled]="true"
            [group]="form">
          </app-input-field>
        }
        <app-input-field
          [label]="data.sysText.caseNumber"
          [control]="form.controls.caseNumber"
          [isDisabled]="true"
          [group]="form">
        </app-input-field>
        <app-input-field
          [label]="data.sysText.leaveType"
          [control]="form.controls.leaveType"
          [isDisabled]="true"
          [group]="form">
        </app-input-field>
      </div>
      <div class="field-col">
        <app-input-field
          [label]="data.sysText.timeframe"
          [control]="form.controls.timeframe"
          [isDisabled]="true"
          [group]="form">
        </app-input-field>
        <app-input-field
          [label]="data.sysText.leaveReason"
          [control]="form.controls.leaveReason"
          [isDisabled]="true"
          [group]="form">
        </app-input-field>
        <app-text-area
          [label]="data.sysText.intermittentFreq"
          [control]="form.controls.intFreq"
          [isDisabled]="true">
        </app-text-area>
      </div>
    </div>
    <app-text-area
      [control]="comments"
      [label]="data.sysText.comments"
      [icon]="'comment'">
    </app-text-area>
    <app-submit-hours-form-array
      #SubmitHoursFormArrayComponent
      [leaveHoursFormArray]="leaveHours"
      [group]="form"
      [sysText]="data.sysText"
      [showLeavePickList]="data.dialogData.showEmployeeCasePickList"
      [employeeCaseControl]="employeeCase"
      [caseInformationInput]="caseInformation">
    </app-submit-hours-form-array>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (showNotificationToggle) {
    <div class="slide-container">
      <app-slide-toggle
        [control]="form.controls.sendNotification"
        [isDisabled]="(isSubmitting$ | async)"
        [label]="data.sysText.submitHoursRequest_sendNotif">
      </app-slide-toggle>
    </div>
  }

  <div>
    @if (!(isMobile$ | async)) {
      <button
        mat-stroked-button
        class="button"
        color="accent"
        type="button"
        [disabled]="isSubmitting"
        (click)="close(false)">
        {{data.sysText.cancel}}
      </button>
    }
    <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the (ngSubmit) guard blocks
    resubmits. no (click): as a form button, pressing it already submits the form -->
    <button
      mat-stroked-button
      class="button"
      color="accent"
      type="submit"
      form="submit-hours-form"
      [disabled]="isSubmitting"
      disabledInteractive
      [showProgress]="isSubmitting"
      [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null">
      {{data.sysText.submit}}
      <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
    </button>
  </div>
</mat-dialog-actions>
